/**
 * The legal documents the console publishes.
 *
 * Authored here, unlike the guides under `features/docs`, which are vendored
 * from the `docs` repository. Each one sits behind a dynamic import, so the
 * text is downloaded only by a reader who opens it. They render through the
 * guide reader (`features/docs/parse.ts`), which never interprets HTML.
 */

export type LegalDocumentId = 'privacy' | 'terms'

export interface LegalDocument {
  id: LegalDocumentId
  title: string
  path: string
  load: () => Promise<string>
}

export const legalDocuments: Record<LegalDocumentId, LegalDocument> = {
  privacy: {
    id: 'privacy',
    title: 'Privacy Policy',
    path: '/app/legal/privacy',
    load: () => import('./content/privacy-policy.md?raw').then((module) => module.default),
  },
  terms: {
    id: 'terms',
    title: 'Terms of Service',
    path: '/app/legal/terms',
    load: () => import('./content/terms-of-service.md?raw').then((module) => module.default),
  },
}
